import Box from "@mui/material/Box";
import SoftTypography from "components/SoftTypography";

const ToolboxDetailHeader = ({ title }) => {
  return (
    <Box>
      <SoftTypography variant="h5" style={{ fontSize: "18px" }} fontWeight="bold" color="dark">
        {title}
      </SoftTypography>
    </Box>
  )
}

export default ToolboxDetailHeader;